// translations/abhaTranslations.ts
export const abhaTranslations = {
    en: {
        // Page titles
        pageTitle: "ABHA Applications",
        abhaApplicationsFor: "ABHA Applications for",
        allCampaigns: "All Campaigns",

        // Table headers
        srNo: "Sr. No.",
        beneficiaryName: "Beneficiary Name",
        mobile: "Mobile",
        aadhar: "Aadhar",
        address: "Address",
        dateOfBirth: "Date Of Birth",
        action: "Action",

        // Buttons
        addAbhaApplication: "Add ABHA Application",
        viewAbhaDetails: "View ABHA Application Details",
        viewProfile: "View Profile",

        // Status
        campCompleted: "Camp Completed",

        // Messages
        noApplicationsFound: "No ABHA applications found",
        loading: "Loading ABHA applications...",
        translating: "Translating...",

        // Search
        searchPlaceholder: "Search by name, mobile, aadhar...",

        // Common
        unknown: "Unknown",
        notAvailable: "N/A",
    },
    mr: {
        // Page titles
        pageTitle: "आभा अर्ज",
        abhaApplicationsFor: "आभा अर्ज",
        allCampaigns: "सर्व शिबिरे",

        // Table headers
        srNo: "अ.क्र.",
        beneficiaryName: "लाभार्थी नाव",
        mobile: "मोबाइल",
        aadhar: "आधार",
        address: "पत्ता",
        dateOfBirth: "जन्मतारीख",
        action: "कृती",

        // Buttons
        addAbhaApplication: "आभा अर्ज जोडा",
        viewAbhaDetails: "आभा अर्ज तपशील पहा",
        viewProfile: "प्रोफाइल पहा",

        // Status
        campCompleted: "शिबीर पूर्ण झाले",

        // Messages
        noApplicationsFound: "आभा अर्ज आढळले नाहीत",
        loading: "आभा अर्ज लोड करत आहे...",
        translating: "भाषांतर करत आहे...",

        // Search
        searchPlaceholder: "नाव, मोबाइल, आधारानुसार शोधा...",

        // Common
        unknown: "अज्ञात",
        notAvailable: "उपलब्ध नाही",
    }
};
